var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-picture text-center",class:_vm.classes},[(_vm.src)?_c('img',{staticClass:"full-width",attrs:{"src":_vm.src}}):_c('i',{staticClass:"fa fa-photo fa-2x no-image"})])}
var staticRenderFns = []

export { render, staticRenderFns }